module.exports = __webpack_public_path__ + "static/media/alert.96370aa0.svg";